import _ from 'lodash';
import React, { Component } from 'react';

import ReactTooltip from 'react-tooltip';

import { EditQuestionModal } from '../../modals';

import Select from 'react-select';

import {
  generateUnsafeHash,
  getOptionValueForSelect,
  getCategoryNameFromId,
  getDimensionFromId,
  getDimensionFamilyFromId,
} from '../../../util';

class AssessmentQuestionsAdminSection extends Component{

  state = {
    questionSearch: '',
    editingQuestion: null,
    viewingAssessmentVersion: 'latest',
    versionsLoaded: false,
    unsavedAssessmentChanges: false,
    updatedLatestVersion: null,
    sortBy: 'order',
  }

  mapQuestion(question){

    const dimensionFamilyData = getDimensionFamilyFromId(question.dimensionFamily);
    const categoryName = getCategoryNameFromId(dimensionFamilyData.categoryId).name || false;
    const experimentId = (question.experimental && question.experimentId) ? question.experimentId : '';

    const questionScoredDimensions = _.map(question.scoredDimensions, dimensionId => {
      return getDimensionFromId(dimensionId);
    });

    const dimensionsAsString = _.map(questionScoredDimensions, 'label').join(', ');

    return {
      ...question,
      dimensionFamilyData,
      categoryName,
      dimensionsAsString,
      searchString: `${question.id} ${question.legacyId} ${question.text} ${question.status} ${dimensionFamilyData.label} ${dimensionFamilyData.name} ${question.questionFormat} ${question.questionType} ${dimensionsAsString} ${categoryName} ${experimentId}`.toLowerCase()
    }
  }
  mapQuestions(questions){
    if(!questions){
      return null;
    }
    else{

      let mappedQuestions = {};

      _.each(questions, question => {
        mappedQuestions[question.id] = this.mapQuestion(question);
      });

      return mappedQuestions;
    }
  }

  mapAssessmentVersions(assessmentVersions){

    let mappedVersions = {};

    _.each(assessmentVersions, version => {
      mappedVersions[version._id] = {
        questions: this.mapQuestions(version.questions),
        versionLabel: version.versionLabel,
        isLatest: version._id === 'latest'
      }
    });

    return _.cloneDeep(mappedVersions);
  }

  attemptInitializeStateFromProps(props, prevProps){
    if(!this.state.versionsLoaded && props.assessmentVersions){

      const mappedAssessmentVersions = this.mapAssessmentVersions(props.assessmentVersions);

      this.setState({
        versionsLoaded: true,
        updatedLatestVersion: _.cloneDeep(mappedAssessmentVersions['latest']),
        assessmentVersions: mappedAssessmentVersions
      });
    }
    //just saved new version
    else if(prevProps.saving && !props.saving && props.assessmentVersions){

      console.log('updating UI after save with new props AVs: ', props.assessmentVersions);

      //these will be updated in new props
      const mappedAssessmentVersions = this.mapAssessmentVersions(props.assessmentVersions);

      this.setState({
        updatedLatestVersion: _.cloneDeep(mappedAssessmentVersions['latest']),
        assessmentVersions: mappedAssessmentVersions
      });
    }
  }

  componentDidMount(){
    this.attemptInitializeStateFromProps(this.props);
  }
  componentDidUpdate(prevProps, prevState){
    this.attemptInitializeStateFromProps(this.props, prevProps);
  }

  renderAssessmentQuestion(question, editable){

    const {
      viewingAssessmentVersion
    } = this.state;

    const {
      id,
      questionIndex,
      text,
      questionFormat,
      questionType,
      dimensionId,
      categoryId,
      reverse,
      legacyId,
      experimentId,
      categoryName,
      status,
      scoredDimensions,
      dimensionsAsString,
      dimensionFamilyData,
    } = question;

    return (
      <div
        key={`question-${id}`}
        className={`question ${status}`}
        onMouseEnter={e => { this.setState({ renderTooltipsForQuestionId: id }); }}
      >
        <div className="question-detail">
          <div className="text">{text}</div>
          <div className={`question-properties ${status}`}>
            <div className={`question-prop question-status ${status}`}>{status}</div>
            <div className={`question-prop question-type`}>{questionType}</div>
            <div className={`question-prop question-format question-format-${questionFormat}`}>{questionFormat}</div>
            {status === 'experimental' && experimentId &&
              <div className={`question-prop question-experiment-id question-experiment-id-${experimentId}`}>{experimentId}</div>
            }
            {dimensionsAsString &&
              <div className={`question-prop question-dimensions`}>{dimensionFamilyData.label}: {dimensionsAsString}</div>
            }
          </div>
          <div className="question-refs">
            <div className="id question-ref">&nbsp;{id}&nbsp;</div>
            {legacyId &&
              <div className="legacyId question-ref">&nbsp;@{legacyId}&nbsp;</div>
            }
            {questionIndex !== null &&
              <div className="index question-ref">&nbsp;#{questionIndex}&nbsp;</div>
            }
          </div>
        </div>

        <div className="question-actions">
          <button
            onClick={() => { this.beginEditingQuestion(question); } }
            className="button grey-outline button-tiny">{this.viewingAssessmentVersionIsEditable() ? 'Edit' : 'View'}</button>
        </div>

        {this.state.renderTooltipsForQuestionId === question.id &&
          <React.Fragment>
            <ReactTooltip id={`react-tooltip-for-question-${question.id}`} effect="solid" place="bottom" />
          </React.Fragment>
        }
      </div>
    )
  }

  beginEditingQuestion(question){
    this.setState({
      editingQuestion: question
    });
  }

  viewingAssessmentVersion(){
    const NULL_ASSESSMENT = {
      assessmentLabel: 'Null',
      questions: [],
    }

    const viewingAssessmentVersion = this.state.viewingAssessmentVersion;

    if(viewingAssessmentVersion === 'latest'){
      //return updated assessment if exists, otherwise return current latest assessment
      if(this.state.updatedLatestVersion){
        return this.state.updatedLatestVersion;
      }
      else if(this.state.assessmentVersions && this.state.assessmentVersions['latest']){
        return this.state.assessmentVersions['latest'];
      }
      else{
        return NULL_ASSESSMENT;
      }
    }
    else{
      if(this.state.assessmentVersions && this.state.assessmentVersions[viewingAssessmentVersion]){
        return this.state.assessmentVersions[viewingAssessmentVersion];
      }
      else{
        return NULL_ASSESSMENT;
      }
    }
  }

  viewingAssessmentVersionIsEditable(){
    return this.state.viewingAssessmentVersion === 'latest';
  }

  filteredAssessmentQuestions(){

    const { questionSearch } = this.state;

    let searchedQuestions = this.viewingAssessmentVersion().questions;

    if(questionSearch && questionSearch !== ''){

      const questionSearchComponents = questionSearch.split(' ');

      searchedQuestions = _.filter(searchedQuestions || [], question => {

        let matchesAllComponents = true;

        _.each(questionSearchComponents, searchComponent => {
          if(question.searchString.indexOf(searchComponent.toLowerCase()) === -1){
            matchesAllComponents = false;
          }
        });

        return matchesAllComponents;
      });
    }

    let sortedQuestions;

    if(this.state.sortBy === 'order'){
      sortedQuestions = _.sortBy(searchedQuestions, 'questionIndex');
    }
    else if(this.state.sortBy === 'dimensionFamily'){
      sortedQuestions = _.sortBy(searchedQuestions, question => {
        return question.dimensionFamilyData.name;
      });
    }
    // else if(this.state.sortBy === 'dimension'){
    //   sortedQuestions = _.sortBy(searchedQuestions, question => {
    //     return question.scoredDimensions[0];
    //   });
    // }
    else if(this.state.sortBy === 'id'){
      sortedQuestions = _.sortBy(searchedQuestions, 'id');
    }
    else if(this.state.sortBy === 'legacyId'){
      sortedQuestions = _.sortBy(searchedQuestions, 'legacyId');
    }

    return sortedQuestions;
  }

  renderVersionSelect(){

    //TODO query these from DB
    const versionOptions = _.map(this.state.assessmentVersions, version => {
      return {
        value: version.isLatest ? 'latest' : version.versionLabel,
        label: version.isLatest ? `Latest (${version.versionLabel})` : version.versionLabel
      }
    });

    const sortedVersionOptions = _.sortBy(versionOptions, versionOption => {
      if(versionOption.value === 'latest'){
        return -99999999999;
      }
      else{
        const versionParts = versionOption.value.split('.');
        return -1 * (parseInt(versionParts[0])*1000. + parseInt(versionParts[1])*1.);
      }
    });

    const currentVersion = this.state.viewingAssessmentVersion;

    return(
      <Select
        placeholder="..."
        classNamePrefix={'react-select'}
        className='react-select-container assessment-version-select'
        value={getOptionValueForSelect(sortedVersionOptions, currentVersion)}
        options={sortedVersionOptions}
        onChange={(option) => { this.setState({ viewingAssessmentVersion: option.value }); } }
        isSearchable={false}
      />
    )
  }

  discardLatestAssessmentChanges(){
    this.setState({
      updatedLatestVersion: _.cloneDeep(this.state.assessmentVersions['latest']),
      unsavedAssessmentChanges: false,
    });
  }

  saveChanges(){

    const { hasMajorChanges } = this.state;

    let questionsWithoutSearchString = _.cloneDeep(this.state.updatedLatestVersion.questions);

    _.each(questionsWithoutSearchString, question => {
      delete question.dimensionFamilyData;
      delete question.categoryName;
      delete question.dimensionsAsString;
      delete question.searchString;
    });

    this.props.updateLatestAssessmentVersion({
      ...this.state.updatedLatestVersion,
      questions: questionsWithoutSearchString,
      versionLabel: hasMajorChanges ? this.getLatestChangesVersionNumber() : this.getCurrentVersionNumber()
    }, () => {
      this.setState({
        unsavedAssessmentChanges: false,
      })
    });
  }

  getLatestChangesVersionNumber(){
    let newVersionMajor = parseInt(this.state.updatedLatestVersion.versionLabel.split('.')[1]);

    if(this.state.unsavedAssessmentChanges){
      newVersionMajor++;
    }

    return `1.${newVersionMajor}`;
  }
  getCurrentVersionNumber(){
    return this.state.updatedLatestVersion.versionLabel;
  }

  renderLatestVersionSave(){

    const { saving } = this.props;
    const changedVersionNumber = this.getLatestChangesVersionNumber();
    const currentVersionNumber = this.getCurrentVersionNumber();

    const { hasMajorChanges } = this.state;

    return(
      <div className="assessment-save-actions">
        <button
          onClick={this.discardLatestAssessmentChanges.bind(this)}
          className="discard-changes button grey-outline button-tiny">Discard changes</button>
        {hasMajorChanges &&
          <button
            onClick={this.saveChanges.bind(this)}
            disabled={this.props.saving}
            className="save-latest-assessment button blue-button button-tiny">{saving ? 'Saving...' : `Save as v${changedVersionNumber}`}</button>
        }
        {!hasMajorChanges &&
          <button
            onClick={this.saveChanges.bind(this)}
            disabled={this.props.saving}
            className="save-latest-assessment button blue-button button-tiny">{saving ? 'Saving...' : `Overwrite v${currentVersionNumber}`}</button>
        }
      </div>
    )
  }

  createQuestion(newQuestion){
    const newQuestionId = generateUnsafeHash();

    const newMappedQuestion = this.mapQuestion({
      ...newQuestion,
      id: newQuestionId
    });

    let updatedQuestions = _.cloneDeep(this.state.updatedLatestVersion.questions);

    updatedQuestions[newQuestionId] = newMappedQuestion;

    const updatedLatestVersion = {
      ...this.state.updatedLatestVersion,
      questions: updatedQuestions
    }

    this.setState({
      unsavedAssessmentChanges: true,
      updatedLatestVersion,
      editingQuestion: null
    });
  }

  updateQuestion(updatedQuestion){

    const updatedAndMappedQuestion = this.mapQuestion(updatedQuestion);

    let updatedQuestions = _.cloneDeep(this.state.updatedLatestVersion.questions);

    let questionToUpdate = _.find(updatedQuestions, { id: updatedQuestion.id });

    //TODO this should add new
    if(!questionToUpdate){
      return;
    }

    let oldQuestionData = _.cloneDeep(questionToUpdate);

    updatedQuestions[updatedQuestion.id] = updatedAndMappedQuestion;

    console.log('oldQuestionData: ', oldQuestionData);
    console.log('updatedQuestion: ', updatedQuestion);

    //have to have old question data, and either question is not disabled or becomes not disabled...and there are changes
    let hasMajorChanges = (oldQuestionData && (oldQuestionData.status !== 'disabled' || updatedQuestion.status !== 'disabled') && (
                          oldQuestionData.status !== updatedQuestion.status ||
                          oldQuestionData.questionType !== updatedQuestion.questionType ||
                          oldQuestionData.questionFormat !== updatedQuestion.questionFormat ||
                          oldQuestionData.reverseScore !== updatedQuestion.reverseScore ||
                          oldQuestionData.dimensionFamily !== updatedQuestion.dimensionFamily ||
                          !_.isEqual(oldQuestionData.scoredDimensions.sort(), updatedQuestion.scoredDimensions.sort())));

    let hasMinorChanges = (oldQuestionData.status !== updatedQuestion.status ||
                          oldQuestionData.questionType !== updatedQuestion.questionType ||
                          oldQuestionData.questionFormat !== updatedQuestion.questionFormat ||
                          oldQuestionData.reverseScore !== updatedQuestion.reverseScore ||
                          oldQuestionData.dimensionFamily !== updatedQuestion.dimensionFamily ||
                          !_.isEqual(oldQuestionData.scoredDimensions.sort(), updatedQuestion.scoredDimensions.sort()));

    _.each(updatedQuestion.choices || {}, (updatedQuestionChoice, newChoiceIndex) => {
      if(oldQuestionData && oldQuestionData.choices[newChoiceIndex].value !== updatedQuestionChoice.value){
        hasMajorChanges = true;
      }
    });

    const updatedLatestVersion = {
      ...this.state.updatedLatestVersion,
      questions: updatedQuestions
    }

    this.setState({
      unsavedAssessmentChanges: (this.state.unsavedAssessmentChanges || hasMajorChanges || hasMinorChanges),
      hasMajorChanges,
      updatedLatestVersion,
      editingQuestion: null
    });
  }

  render(){

    const { sortBy } = this.state;
    const viewingAssessmentVersionIsEditable = this.viewingAssessmentVersionIsEditable();

    return(
      <div className="manage-assessment-questions">
        <p className="intro-text">Add, edit, hide, or delete questions, and toggle which dimensions score which questions.</p>
        <p className="intro-text"><small>Modifying question text is done via the questions localizations file and will immediately update all versions of the assessment, and all organizations. Adding/removing questions or updating scoring/visibility will create a new assessment version (1.X). These changes will <b>not be</b> automatically applied to organizations which have not enabled automatic assessment updates. Any in-progress assessments will not be affected by new versions.</small></p>
        <div className="top">
          <input
            value={this.state.questionSearch}
            onChange={e => { this.setState({ questionSearch: e.target.value }) }}
            type="text" className="question-search" placeholder="Search questions..." />
          <div
            onClick={() => { this.beginEditingQuestion({  }); }}
            className="new-question">+ New Question</div>

          {!this.state.unsavedAssessmentChanges && this.renderVersionSelect()}
          {this.state.unsavedAssessmentChanges && this.renderLatestVersionSave()}
        </div>
        <div className="sort-by">
          <div className="label">Sort By: </div>
          <div
            onClick={() => { this.setState({ sortBy: 'order' }); }}
            className={`sort-option ${sortBy === 'order' ? 'active' : ''}`}
          >Question Order</div>
          <div
            onClick={() => { this.setState({ sortBy: 'id' }); }}
            className={`sort-option ${sortBy === 'id' ? 'active' : ''}`}
          >Question Id</div>
          <div
            onClick={() => { this.setState({ sortBy: 'legacyId' }); }}
            className={`sort-option ${sortBy === 'legacyId' ? 'active' : ''}`}
          >Legacy Id</div>
          <div
            onClick={() => { this.setState({ sortBy: 'dimensionFamily' }); }}
            className={`sort-option ${sortBy === 'dimensionFamily' ? 'active' : ''}`}
          >Dimensions</div>
        </div>
        <div className="questions">
          <div className={`questions-list ${viewingAssessmentVersionIsEditable ? 'editable' : 'readonly'}`}>
            {_.map(this.filteredAssessmentQuestions(), question => { return this.renderAssessmentQuestion(question, viewingAssessmentVersionIsEditable); })}
          </div>
          <div className="questions-list-scroll-indicator"></div>
        </div>

        <EditQuestionModal
          question={this.state.editingQuestion}
          editable={viewingAssessmentVersionIsEditable}
          visible={this.state.editingQuestion}
          updateQuestion={this.updateQuestion.bind(this)}
          createQuestion={this.createQuestion.bind(this)}
          hide={() => { this.setState({ editingQuestion: null }) }}
        />
      </div>
    )
  }
}

export default AssessmentQuestionsAdminSection;



// WEBPACK FOOTER //
// ./src/components/admin/sections/assessmentQuestionsAdminSection.js